import {GenericConstraintIcon} from "./constraints/ConstraintIcons";

export const NoIcon = GenericConstraintIcon;